import api from './axiosInstance';

export const workerTypeApi = {
  listWorkerTypes: () => api.get('/worker-types'),

  updateSetting: (workerTypeId, data) =>
    api.put(`/worker-types/${workerTypeId}/settings`, data),
};
